
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";
import { ISupportRequest, IUser } from "./SupportRequestService";

export enum ICommentStatus {
    ACTIVE = "ACTIVE",
    DELETED = "DELETED",
}

export enum IAttachmentType {
    IMAGE = "IMAGE",
    AUDIO = "AUDIO",
    VIDEO = "VIDEO",
    UNKNOWN = "UNKNOWN",
}

export interface IAttachment {
    name: string;
    size: string;
    location: string;
    type: IAttachmentType;
}

export interface ISupportRequestComment {
    user: IUser;
    comment: string;
    user_id: string;
    user_type: string;
    created_at: string;
    updated_at: string;
    external_id: string;
    status: ICommentStatus;
    attachments: IAttachment[];
    support_request: ISupportRequest;
}

export class SupportRequestCommentService extends BaseService {

    protected static instance: SupportRequestCommentService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportRequestCommentService.instance) SupportRequestCommentService.instance = new SupportRequestCommentService();
        return SupportRequestCommentService.instance;
    }

    querySupportRequestComments(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/request/comment", { cache: true, query: this.normalizeParams(query) }));
    }

    getSingleSupportRequestComment(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/request/comment/${id}`));
    }

    createSupportTicketComment(payload: NoseurObject<any>): Promise<any> {
        return this.report(this.transport.post(`/hera/api/v1/support/request/comment`, payload));
    }

}
